import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getNeededDateFormat } from '../../../../../../helper'
import { isInvoiceOrder } from '../../../../../../hooks/useCancellationWindow/helper'
import { useOrderInvoiceAction } from '../useOrderInvoiceAction'

export const useOrderInvoiceButtons = ({ order, isOpen, openOrderInvoice, zIndex }) => {
	const { t } = useTranslation()
	const [isRecipientModalOpen, setIsRecipientModalOpen] = useState(false)
	const { currentInvoice, orderInvoiceable, createInvoice, isCreating } = useOrderInvoiceAction(isOpen ? order : null)

	const openRecipientModal = useCallback(() => {
		setIsRecipientModalOpen(true)
	}, [])

	const closeRecipientModal = useCallback(() => {
		setIsRecipientModalOpen(false)
	}, [])

	const submitRecipient = useCallback(async (recipient) => {
		const isInvoiceRequestResolved = await createInvoice(recipient)
		if (!isInvoiceRequestResolved) {
			throw new Error('Paid order invoice was not created')
		}
		setIsRecipientModalOpen(false)
	}, [createInvoice])

	const goToInvoiceText = currentInvoice
		? t('order.modal.go_to_invoice_number', { number: currentInvoice.invoiceNumber, date: getNeededDateFormat(currentInvoice.createDate) })
		: t('order.modal.go_to_invoice')

	return {
		goToInvoiceButton: { icon: 'go-to', text: goToInvoiceText, onClick: () => openOrderInvoice(order), show: isInvoiceOrder(order) || !!currentInvoice },
		createInvoiceButton: { icon: 'invoice', text: t('order.modal.create_invoice'), onClick: openRecipientModal, show: orderInvoiceable, disabled: isCreating },
		recipientModalProps: {
			isOpen: isRecipientModalOpen,
			close: closeRecipientModal,
			onSubmit: submitRecipient,
			paidOrderMode: true,
			customer: order?.customer ?? null,
			returnZIndex: zIndex,
		},
	}
}
